import styled from 'styled-components';

export default styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 10px;
  text-decoration: none;
`;
